export default __webpack_public_path__ + "static/media/formato60x120.c9338bb5.svg";